import { render, staticRenderFns } from "./Statutory.vue?vue&type=template&id=3e6fbe84&scoped=true"
import script from "./Statutory.vue?vue&type=script&lang=js"
export * from "./Statutory.vue?vue&type=script&lang=js"
import style0 from "./Statutory.vue?vue&type=style&index=0&id=3e6fbe84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6fbe84",
  null
  
)

export default component.exports